/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { PERSON_CREDIT_ROLES } from '@repo/config';
import { z } from 'zod';

export const personCreditBodySchema = z.object({
  collectionId: z.number(),
  role: z.enum(PERSON_CREDIT_ROLES),
  characterName: z.string().nullable().optional(),
  department: z.string().nullable().optional(),
  job: z.string().nullable().optional(),
  sortOrder: z.number().optional(),
});

export const collectionCreditBodySchema = z.object({
  personId: z.number(),
  role: z.enum(PERSON_CREDIT_ROLES),
  characterName: z.string().nullable().optional(),
  department: z.string().nullable().optional(),
  job: z.string().nullable().optional(),
  sortOrder: z.number().optional(),
});

export type IPersonCreditBody = z.infer<typeof personCreditBodySchema>;
export type ICollectionCreditBody = z.infer<typeof collectionCreditBodySchema>;
